// FB 17118
import React, { useContext, useState, useEffect, useCallback, useRef } from 'react';
import _ from 'lodash';
//import { renderContentFromMetadata } from '@jutro/uiconfig'
import { MetadataContent } from '@jutro/uiconfig';
import { useAuthentication, AUTH_ERRORS} from 'gw-digital-auth-react';
import { withIntl,IntlContext,TranslatorContext } from '@jutro/locale';
import metadata from './RIUserEdit.metadata.json5';
import messages from './RIUserEdit.messages';
import styles from './RIUserEdit.module.scss';
import { UserService } from 'gw-capability-ri-policy';

const USER_UPDATED = 'userUpdated', USER_ADDED = 'userAdded',  ADD_USER = 'addUser', EDIT_USER = 'editUser';

const validateEmail = (email)  => {   
    const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    return re.test(email.toLowerCase());
};

const RIUserEdit = (props) => {
    const { method, todo, selectedUser, riUserListData } = props;    

    const { authHeader } = useAuthentication();  
    const translator = useContext(TranslatorContext);
    
    const [isManager, setIsManager] = useState(false);
    const [isClaims, setIsClaims] = useState(false);  
    const [isBilling, setIsBilling] = useState(false);
    const [isMarketing, setIsMarketing] = useState(false);
    const [user, setUser] = useState({});    
    const [pageError, setPageError] = useState();     
    const [isShowError, setIsShowError] = useState({});      
    
    const testWebCode = useRef();

    useEffect(() => {
        if(todo === EDIT_USER){
            setUser(selectedUser)
            initAccessFlag(selectedUser);
        }else{
            setUser({})
        }
        
    },[selectedUser, todo]);

    const goBack = useCallback(() => {
        method[0]();
    });
    const setMessage = useCallback((messageId) => {
        method[1](messageId);
    });
    const setTheUser = (user) =>{
        method[2](user);
    };
    const setLoadingState = (value) => {
        method[3](value);
    };
    const setErrorText = (value) =>{
        method[4](value);
    };

    const cancel = useCallback(() => {
        setErrorText();
        goBack();
    });

    const addUser = useCallback((user) => {
        setTheUser(user);
        const userObj = setUserObj(user);        
        addInsuredUser(userObj);    
            
    });

    const updateUser =  useCallback((user) => {        
        setTheUser(user);
        const userObj = setUserObj(user);           
        updateInsuredUser(userObj);   
        
    });

    const updateInsuredUser = (insuredUser) => {
        setLoadingState(true);
        
        UserService.updateInsuredUser(insuredUser, authHeader)
        .then((data) =>{    
            
            setLoadingState(false);
            if(data.success){     
                setErrorText();     
                setMessage(USER_UPDATED);     
                goBack();
            }else if(data.error){
                let error = data.message;         
                if(error.includes('LdapUser not found'))  {
                    error = `The user "${insuredUser.userId}" is not synchronized.`
                }   
                setErrorText(error);                     
            }

        })
        .catch((err) => {           
            setLoadingState(false);                     
            if(!_.isEmpty(err)){
                setErrorText('Error with service');
            }
        });  
        
    };

    const addInsuredUser = (insuredUser) => {
        setLoadingState(true);
        
        UserService.addInsuredUser(insuredUser, authHeader)
        .then((data) =>{            
            setLoadingState(false);   
            if(data.success){     
                setErrorText();           
                setMessage(USER_ADDED);     
                goBack();         
            }else if(data.error){
                const error = data.message;            
                setErrorText(error);
            }          
        })
        .catch((err) => {        
            setLoadingState(false);           
            if(!_.isEmpty(err)){
                setErrorText('Error with service');
            }           
        });
    };

    const setUserObj = (user) => {       
            const objData = {  
                userId: user.userId,
                firstName: user.firstName,
                lastName: user.lastName,
                emailAddr: user.emailAddr,
                policyholderName: user.insuredName,
                userManager: user.userManager,
                authorizationCode: user.authorizationCode,
                policyAccess: true,
                claimsAccess: user.claim,
                accountingAccess: user.billing,
                producerNumber: user.producerNo,
                marketingAccess: user.marketing,
                password: "Republic01@",
                webAdmin: true
            };                                                  
        return objData;
    };           

    const readValue = useCallback(
        (id, path) => {                 
            return _.get(user, path);
        } , [user]
    );

    const writeValue = useCallback(
        (value, path) => {
            setPageError();
            setUser({...user, [path]: value});
        },
        [user]
    );

    const valueChangeFn = useCallback((value,index,property) => {
        switch(property.id) {
            case 'isUserManager':
                setIsManager(value);
                break;
            case 'isClaims':
                setIsClaims(value);
                break;
            case 'isBilling':
                setIsBilling(value);
                break;
            case 'isMarketing':
                setIsMarketing(value);
                break;
        }
    });

    const initAccessFlag = (selectedUser) => {
        setIsManager(selectedUser.userManager);
        setIsBilling(selectedUser.billing);
        setIsClaims(selectedUser.claim);
        setIsMarketing(selectedUser.marketing);
    };

    const setAccessFlag = () => {
        user.userManager = isManager;
        user.billing = isBilling;
        user.claim = isClaims;
        user.marketing = isMarketing;
        setUser(user);
    };

    const handleSubmit = useCallback(
        (evt) => {
            if (evt) {
                evt.preventDefault();
            }
            setAccessFlag();
            
            if(validate()){
                if(todo === ADD_USER){
                    addUser(user);
                }else if(todo === EDIT_USER){
                    updateUser(user);
                }
            }
            
        }
    );

    const validateUserId = useCallback((value,index,property) =>{        
        setUser({...user, ['userId']: value});
        if(userIdExist(value)){
            setPageError('userNameExist');
            setIsShowError({userId:true});
        }else{
            setPageError();
            setIsShowError({});
        }
    },[user]);

    const userIdExist = useCallback((userId) => {             
        
        let filteredUserList = riUserListData.find((user) =>{
            return user.userId.toLowerCase() == userId.toLowerCase();
        });
        
        return filteredUserList;
    });

    const validateWebCode = useCallback((obj,input) => {
    
        if( isEmpty(input.value) ) {         
            setPageError('invalidWebAccessCode');
            setIsShowError({authorizationCode:true});            
            return false;
        }
        if( isNaN(input.value.trim()) ) {            
            setPageError('invalidWebAccessCode2');
            setIsShowError({authorizationCode:true});
            inputElementError('authorizationCode', true);
            return false;
        }       
        inputElementError('authorizationCode', false);
        return true;
    });

    const validateEmailField = useCallback((obj,input) => {
    
        if( isEmpty(input.value) ) {         
            setPageError('invalidEmail');
            setIsShowError({email:true});            
            return false;
        }
        if( !validateEmail(input.value.trim()) ) {            
            setPageError('invalidEmail');
            setIsShowError({email:true});
            inputElementError('email', true);
            return false;
        }   
        inputElementError('email', false);
        return true;
    });
    const inputElementError = (name, error) => {
        const elementContainer = document.querySelector(`#${name}`); 
        elementContainer.style.borderColor = error? '#C4221F' : '#7d91ac';    
    };
    const isEmpty = (value) => {
        if( value === undefined || _.isEmpty(value.trim()) ) {                              
            return true;
        }
        return false;
    };

    const validate = () => {
        setIsShowError({});
        
        if (todo === ADD_USER && isEmpty(user.userId) ) {                        
            setPageError('invalidUserName');
            setIsShowError({userId:true});
            return false;
        }
        
        if( todo === ADD_USER &&  userIdExist(user.userId) ){
            setPageError('userNameExist');
            setIsShowError({userId:true});
            return false;
        }

        if( isEmpty(user.firstName) ) {      
            setPageError('invalidFirstName');
            setIsShowError({firstName:true});
            return false;
        }
        if( isEmpty(user.lastName) ) {        
            setPageError('invalidLastName');
            setIsShowError({lastName:true});
            return false;
        }
        if( isEmpty(user.emailAddr) || !validateEmail(user.emailAddr.trim()) ) {            
            setPageError('invalidEmail');
            setIsShowError({email:true});
            return false;
        }
        if( isEmpty(user.authorizationCode) ) {         
            setPageError('invalidWebAccessCode');
            setIsShowError({authorizationCode:true});
            return false;
        }
        if( isNaN(user.authorizationCode.trim()) ) {            
            setPageError('invalidWebAccessCode2');
            setIsShowError({authorizationCode:true});
            return false;
        }       
        if( isEmpty(user.insuredName) ) {        
            setPageError('invalidInsuredName');
            setIsShowError({insuredName:true});
            return false;
        }
        // if( user.producerNo === undefined || _.isEmpty(user.producerNo.trim().toString())){       
        if( isEmpty(user.producerNo) ) {    
            setPageError('invalidProducerNo');
            setIsShowError({producerNo:true});
            return false;
        }

        if( isNaN(user.producerNo.trim()) ) {       
            setPageError('invalidProducerNo2');
            setIsShowError({producerNo:true});
            return false;
        }

        return true;
    };
    
    const overrides = {
        '@field': {
            onValueChange: writeValue
        },         
        errorMsg: {
            visible: !_.isUndefined(pageError),
            message: translator(messages[pageError]),
            type: 'error'
        },         
        titleText:{ content: todo === ADD_USER ? 'Add New User' : 'Edit User'},
        accessGroupLabel: {content: "Access:"},
        isUserManager:{value: isManager},
        isClaims:{value: isClaims},        
        isBilling:{value: isBilling},
        isMarketing:{value: isMarketing},
        userProfileForm: {onSubmit: handleSubmit}, 
        saveButton: {trigger: handleSubmit},
        userId: {
            readOnly: todo === EDIT_USER,
            showErrors: isShowError.userId
        },
        firstname: {showErrors: isShowError.firstName},
        lastname: {showErrors: isShowError.lastName},
        email: {showErrors: isShowError.email},
        authorizationCode: {
            showErrors: isShowError.authorizationCode
        },
        insuredName: {showErrors: isShowError.insuredName},
        producerNo: {showErrors: isShowError.producerNo},
    };

    const resolvers = {
        resolveClassNameMap: styles,
        resolveValue: readValue,
        resolveCallbackMap: {
            goBack,
            valueChangeFn,
            setAccessFlag,
            initAccessFlag,
            addUser,
            updateUser,
            userIdExist,
            validateUserId,
            cancel,
            validateWebCode,
            validateEmailField
        }
    };
	
    //return renderContentFromMetadata(metadata.pageContent, overrides, resolvers);
    return (
        <MetadataContent
            uiProps={metadata.pageContent}
            overrideProps={overrides}
            {...resolvers}
        />
    );
};

export default withIntl(RIUserEdit);


